import { styled, SxProps } from '@mui/material';
import { headingFontBold, vars } from '../../../Theme';
import { TreeItem, treeItemClasses, TreeItemProps } from '@mui/x-tree-view';

/**
 * Creates sx Styles for the label text element.
 * @param flexGrow - Value for flexGrow style.
 */
export const labelTextStyles = (flexGrow: number): SxProps => ({
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: '14px',
    lineHeight: '40px',
    overflow: 'hidden',
    ...headingFontBold,
    flexGrow,
});

/**
 * Custom styles for TreeItemCategory and TreeItemProject.
 */
export default styled(TreeItem, {
    shouldForwardProp: prop =>
        !['paddingLeft', 'disableTransition', 'isExpandedAll'].includes(prop as string),
})<DynamicTreeItemProps>(({ theme, paddingLeft, disableTransition, isExpandedAll }) => {
    return {
        color: theme.palette.text.primary,

        [`& .${treeItemClasses.content}`]: {
            padding: 0,
            paddingLeft: paddingLeft,

            [`& .${treeItemClasses.iconContainer}`]: {
                margin: 0,
                width: '20px',
            },

            [`& .${treeItemClasses.label}`]: {
                fontSize: 'inherit',
                padding: 0,

                [`& svg`]: {
                    verticalAlign: 'middle',
                },
            },

            '&.Mui-selected': {
                color: vars.brandGreen,
                backgroundColor: 'transparent',
                '&:hover': {
                    backgroundColor: vars.bgGreenHover,
                },
                '&.Mui-focused': {
                    backgroundColor: vars.bgGreen,
                    borderRadius: '5px',
                    '&:hover': {
                        backgroundColor: vars.bgGreenHover,
                    },
                },
            },
        },
        [`& .${treeItemClasses.groupTransition}`]: {
            marginLeft: 0,
            transition: isExpandedAll ? 'inherit' : disableTransition ? 'none' : 'inherit',
        },
    };
});

interface DynamicTreeItemProps extends TreeItemProps {
    paddingLeft?: number;

    disableTransition?: boolean;

    isExpandedAll?: boolean;
}
